import { type Signal, effect, signal } from "@preact/signals";

export type FPS = 120 | 60 | 30;
export type Resolution = "4k" | "1440p" | "1080p" | "720p";

export const validFPS: FPS[] = [120, 60, 30];
export const validResolutions: Resolution[] = ["4k", "1440p", "1080p", "720p"];

const error = signal<unknown>();

const showSideBar = signal<boolean>(false);

const audioID = signal(localStorage.getItem("audioID") ?? "");
const videoID = signal(localStorage.getItem("videoID") ?? "");

const fps: Signal<FPS> = (() => {
    let fps = Number.parseInt(localStorage.getItem("fps") || "60", 10) || 60;
    if (!validFPS.includes(fps as FPS)) {
        fps = 60;
    }
    return signal(fps as FPS);
})();

const setFPS = (value: string | number) => {
    let num = typeof value === "string" ? (Number.parseInt(value, 10) as FPS) : (value as FPS);
    if (!validFPS.includes(num as FPS)) {
        num = 60;
    }
    fps.value = num;
};

const resolution: Signal<Resolution> = (() => {
    let res = localStorage.getItem("resolution") || "1080p";
    if (!validResolutions.includes(res as Resolution)) {
        res = "1080p";
    }
    return signal(res as Resolution);
})();

const setResolution = (value: string) => {
    console.log(value);
    let res = value as Resolution;
    if (!validResolutions.includes(res as Resolution)) {
        res = "1080p";
    }
    resolution.value = res;
};

const volume = (() => {
    let vol = Number.parseFloat(localStorage.getItem("volume") ?? "1") ?? 1;
    if (vol < 0 || vol > 1) {
        vol = 1;
    }
    return signal(vol);
})();

effect(() => {
    localStorage.setItem("audioID", audioID.value);
});

effect(() => {
    localStorage.setItem("videoID", videoID.value);
});

effect(() => {
    localStorage.setItem("fps", fps.value.toString());
});

effect(() => {
    localStorage.setItem("resolution", resolution.value.toString());
});

effect(() => {
    localStorage.setItem("volume", volume.value.toString());
});

export { error, audioID, fps, setFPS, resolution, setResolution, showSideBar, videoID, volume };
